export default __webpack_public_path__ + "ec29f4609ad91a680b526056efaa46b9.png";